// replaceToLivestreamRoom.js
'use strict';
import { replace } from '../action/navigationAction.js';
import getUserData from '../selector/getUserData.js';
import getUserProfileUrl from '../resource/getUserProfileUrl.js';
import { LIVESTREAM_PATH } from '../resource/liveStreamConstants.js';

/**
 * Replace to livestream room with lazy username resolution
 * @kind action
 * @param {Object} params - Parameters object
 * @param {string} params.streamId - Stream ID
 * @param {string} [params.search=''] - URL search parameters
 * @returns {Function} Redux thunk action.
 * @example
 * replaceToLivestreamRoom({ streamId: '123', search: '?foo=bar' })
 */
const replaceToLivestreamRoom =
  ({ streamId, search = '' }) =>
  (dispatch, getState) => {
    const username = getUserData(getState(), streamId, 'username');
    return dispatch(
      replace({
        pathname: getUserProfileUrl({
          userId: streamId,
          username,
          subPath: LIVESTREAM_PATH,
        }),
        search,
      })
    );
  };

export default replaceToLivestreamRoom;
